import React, { ComponentType, FC, SVGProps } from 'react'

import { cn } from '../../../lib/utils'

import { ISelectedCard } from '../../../models/users/user.interface'
import { IPaymentType } from '../../../types/payment'

interface MarkPaymentMethodProps {
  icon: ComponentType<SVGProps<SVGSVGElement>>
  type: IPaymentType
  label: string
  selectedCard: ISelectedCard
  setSelectedCard: (value: ISelectedCard) => void
}
export const MarkPaymentMethod: FC<MarkPaymentMethodProps> = ({
  icon,
  type,
  label,
  selectedCard,
  setSelectedCard,
}) => {
  const Icon = icon

  return (
    <div
      className={cn(
        'w-full text-sm py-4 pr-2.5 pl-14 flex items-center gap-2 flex-center relative mb-2.5 border rounded-lg focus:border-blue-500 transition-all',
        selectedCard.type === type
          ? 'bg-SeabiscuitMainThemeColor/5 border-SeabiscuitMainThemeColor/5 text-SeabiscuitMainThemeColor'
          : 'border-SeabiscuitLightThemeColorD3 text-SeabiscuitDark200ThemeColor',
        'group cursor-pointer hover:bg-SeabiscuitMainThemeColor/5 hover:border-SeabiscuitMainThemeColor/5 hover:text-SeabiscuitMainThemeColor'
      )}
      onClick={() => setSelectedCard({ type: type, pmId: '', cardNumber: '' })}
    >
      <div className="flex items-center">
        <Icon
          className={cn(
            'absolute z-10 left-4 top-1/2 -translate-y-1/2 w-[22px] group-hover:fill-SeabiscuitMainThemeColor transition-all',
            selectedCard.type === type
              ? 'fill-SeabiscuitMainThemeColor'
              : 'fill-SeabiscuitDark200ThemeColor'
          )}
        />
        {label}
      </div>
    </div>
  )
}
